module.exports = __webpack_public_path__ + "img/smart.d39c8fbf.png";